import moment from "moment";
import { getLanguage } from "@/helpers/local-storage";

function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatDateHR = (value: string, locale = 'es-mx', need_seconds = false) => {
    let locale_app = locale;
    const current = getLanguage();
    switch (true) {
        case (current.includes('en')):
            locale_app = 'en-us';
            break
        default:
            locale_app = 'es-mx';
            break;
    }

    moment.locale(locale_app);
    if (need_seconds) {

        return `${moment(value).format('DD')}/${capitalizeFirstLetter(moment(value).format('MMM').toLowerCase().split('.')[0])}/${moment(value).year()} ${moment(value).format('HH:mm:ss')} hrs.`;
    }

    // return `${moment(value).format('DD')}/${capitalizeFirstLetter(moment(value).format('MMM').toLowerCase().split('.')[0])}/${moment(value).year()} ${moment(value).format('HH:mm')} hrs.`;
    return `${moment(value).format('DD')}/${capitalizeFirstLetter(moment(value).format('MMM').toLowerCase().split('.')[0])}/${moment(value).year()}`;
};